<form [formGroup]="searchForm">
    <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">

        <checkbox-input-ctrl [caption]="'claims-center.claimMessages.onlyPriority'" [formControlName]="'onlyPriority'">
        </checkbox-input-ctrl>

        <div fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <button kendoButton (click)="searchAndResetPagesClick()" icon="search" type="submit"> </button>
        </div>
    </div>
</form>


<kendo-grid [data]="view | async" [loading]="this.loading" [pageSize]="rowsPerPage$ | async" [skip]="skip$ | async"
    [pageable]="true" [rowSelected]="isRowSelected" [selectable]="selectableSettings" scrollable="none"
    serverPaging="true" (dataStateChange)="dataStateChange($event)" (pageChange)="pageChange($event)" [size]="'small'">

    <kendo-grid-column field="claimInfo" title="{{'claims-center.claimMessages.claimInfo' | translate}}" [width]="220">
        <ng-template kendoGridCellTemplate let-message="dataItem">
            <div fxLayout="column">
                <span>{{message.contactInfo}}</span>
                <span>{{message.contactPhoneNumber}}</span>
                <span class="small-info">{{message.claimNumber}} </span>
                <span class="small-info">{{message.claimCarInfo}} </span>
                <span class="small-info">{{message.claimCarVin}} </span>
                <strong class="small-info">{{message.orderingPartyName}} </strong>
            </div>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="isPriority" title="{{'claims-center.claimMessages.priorityColumn' | translate}}" [width]="70"
        [headerStyle]="{'text-align':'center'}" [style]="{'vertical-align':'middle'}">
        <ng-template kendoGridCellTemplate let-message="dataItem">
            <div fxLayoutAlign="center center">
                <kendo-icon *ngIf="message.isPriority" name="exclamation-circle" themeColor="error" size="xxlarge"
                    title="{{'claims-center.claimMessages.isPriority' | translate}}"></kendo-icon>
            </div>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="messageInfo" title="{{'claims-center.claimMessages.messageInfo' | translate}}">
        <ng-template kendoGridCellTemplate let-message="dataItem">
            <div fxLayoutAlign="start center">
                <div fxLayout="column" class="message-box" fxFlex="100">

                    <div fxLayout="row">
                        <!-- <app-sending-channel-icon [sendingChannel]="message.sendingChannelTypeId"
                            [size]="24"></app-sending-channel-icon> -->
                        <kendo-icon *ngIf="message.isPriority" name="exclamation-circle" themeColor="error" class="priority-icon"
                            title="{{'claims-center.claimMessages.isPriority' | translate}}"></kendo-icon>
                        <strong>{{ message.title }}</strong>
                        <div class="message-info">
                            - <span [title]="message.createdBy">{{ message.senderInfo}}</span> <strong>({{
                                message.senderRoleId | staticDictionaryCaption:'recipientRole' |async}})</strong>
                            - {{message.timestamp | date:'yyyy-MM-dd HH:mm:ss' }}
                        </div>
                    </div>

                    <div fxLayout="row wrap">
                        <div>
                            <span>{{ message.contentText }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="isReadConfirmationRequired"
        title="{{'claims-center.claimMessages.isReadConfirmationRequiredColumn' | translate}}" [width]="220">
        <ng-template kendoGridCellTemplate let-message="dataItem">
            <div fxLayout="column">
                <div *ngIf="message.isReadConfirmationRequired && !message.readConfirmationSent" fxLayout="column">
                    <div fxLayout="row">
                        <button type="button" kendoButton (click)="confirmReading(message)" icon="check">
                            {{'claims-center.claimMessages.confirmReading' | translate}}</button>
                    </div>
                    <div fxLayout="row">
                        <strong
                            class="small-info info-label">{{'claims-center.claimMessages.senderIsAskingForReadingConfiramtion'
                            | translate}}</strong>
                    </div>
                </div>
            </div>

            <div *ngIf="message.isReadConfirmationRequired && message.readConfirmationSent" fxLayout="row wrap">
                <span class="small-info">{{'claims-center.claimMessages.readConfirmationSent' | translate}}
                    : </span>
                <strong>{{message.readConfirmationSent | date:'yyyy-MM-dd HH:mm:ss' }}</strong>
            </div>

            <div fxLayout="column">
                <div *ngIf="!message.isReadConfirmationRequired && !message.readDate" fxLayout="column">
                    <div fxLayout="row">
                        <button type="button" kendoButton (click)="markAsRead(message)" icon="letter">
                            {{'claims-center.claimMessages.markAsRead' | translate}}</button>
                    </div>
                </div>
            </div>

            <div *ngIf="!message.isReadConfirmationRequired && message.readDate" fxLayout="row wrap">
                <span class="small-info">{{'claims-center.claimMessages.readDate' | translate}}
                    : </span>
                <strong>{{message.readDate | date:'yyyy-MM-dd HH:mm:ss' }}</strong>
            </div>


        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="claimInfo" title="{{'claims-center.claimMessages.actions' | translate}}" [width]="180">
        <ng-template kendoGridCellTemplate let-message="dataItem">
            <button type="button" kendoButton (click)="doService(message)">
                <img src="./assets/img/communication.png" [width]='16' alt="communication" />
                {{'claims-center.claimMessages.goToMessageThread' | translate}}</button>
        </ng-template>
    </kendo-grid-column>

</kendo-grid>
